/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import { toggleDeactivate } from "services/apis";
import { toggleUserVerify } from "services/apis";

function PlatformSettings() {
  const { userDetail: user } = useSelector((state) => state.userDetail);

  // Local state for toggling
  const [isDeactivate, setIsDeactivate] = useState(user.isDeactivate);
  const [isVerified, setIsVerified] = useState(user.isVerified);

  const handleToggle = async (type) => {
    // Save the current state in case the API call fails
    const previousdeactivateState = isDeactivate;
    const previousVerifyState = isVerified;

    try {
      // Toggle locally for immediate UI response
      if (type === "deactivate") {
        setIsDeactivate((prev) => !prev);
      } else if (type === "verify") {
        setIsVerified((prev) => !prev);
      }

      // Make the appropriate API call
      const Email={
        "email":user.email
    }
      const apiCall = type === "deactivate" ? toggleDeactivate(Email) : toggleUserVerify(Email);
      await apiCall;

    } catch (error) {
      console.error("Toggle:", error);

      // Revert the toggle if the API call fails
      if (type === "deactivate") {
        console.log('deactivate: called',previousdeactivateState);
        
        setIsDeactivate(previousdeactivateState);
      } else if (type === "verify") {
        console.log('verify: called',previousVerifyState);

        setIsVerified(previousVerifyState);
      }
    }
  };

  return (
    <Card sx={{ boxShadow: "none" }}>
      <MDBox>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Control Panel
        </MDTypography>
      </MDBox>
      <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
        {/* deactivate Toggle */}
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <MDBox mt={0.5}>
            <Switch
              checked={isDeactivate}
              onChange={() => handleToggle("deactivate")}
            />
          </MDBox>
          <MDBox width="80%" ml={0.5}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Deactivate User
            </MDTypography>
          </MDBox>
        </MDBox>

        {/* Verify Toggle */}
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <MDBox mt={0.5}>
            <Switch
              checked={isVerified}
              onChange={() => handleToggle("verify")}
            />
          </MDBox>
          <MDBox width="80%" ml={0.5}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Verification status
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default PlatformSettings;
